/** sessionStorage key for open dashboard workspace tabs. */
export const ACTIVE_TABS_STORAGE_KEY = 'activeTabs';

/** Clears persisted workspace tabs (e.g. on logout). Survives F5 until cleared. */
export function clearActiveTabsSession(): void {
  try {
    sessionStorage.removeItem(ACTIVE_TABS_STORAGE_KEY);
  } catch {
    // ignore storage errors
  }
}
